/* eslint-disable camelcase */
export default {
	init: false,

	type: null,
	data: null,
	last_import: null,
	last_import_count: 0,
	status: null,
};
